var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfigured(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 55.542 48.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4810",
    "data-name": "Group 4810",
    transform: "translate(0.001 -30.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4802",
    "data-name": "Group 4802",
    transform: "translate(-0.001 30.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6069",
    "data-name": "Path 6069",
    d: "M75.458,208.964a5.922,5.922,0,1,0-5.922,5.921A5.928,5.928,0,0,0,75.458,208.964Zm-9.673,0a3.752,3.752,0,1,1,3.751,3.751A3.756,3.756,0,0,1,65.785,208.964Z",
    transform: "translate(-56.714 -184.287)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6070",
    "data-name": "Path 6070",
    d: "M13.943,158.717A2.979,2.979,0,0,0,16.8,156.54l.319-1.157a.226.226,0,0,1,.124-.148,11.112,11.112,0,0,0,2.207-1.277.231.231,0,0,1,.195-.035l1.165.3a2.979,2.979,0,0,0,3.314-1.389l1.119-1.94a2.977,2.977,0,0,0-.454-3.566l-.843-.856a.227.227,0,0,1-.066-.184,11.192,11.192,0,0,0,0-2.551.223.223,0,0,1,.066-.182l.845-.859a2.977,2.977,0,0,0,.453-3.564l-1.12-1.941a2.979,2.979,0,0,0-3.315-1.388l-1.165.3a.23.23,0,0,1-.192-.034,11.115,11.115,0,0,0-2.208-1.278.226.226,0,0,1-.125-.148l-.319-1.159a2.978,2.978,0,0,0-2.86-2.175H11.7a2.976,2.976,0,0,0-2.86,2.177l-.32,1.158a.225.225,0,0,1-.125.147,11.154,11.154,0,0,0-2.21,1.278.228.228,0,0,1-.192.034l-1.165-.3a2.978,2.978,0,0,0-3.313,1.389L.4,139.132A2.973,2.973,0,0,0,.85,142.7l.842.856a.227.227,0,0,1,.067.185,11.209,11.209,0,0,0,0,2.552.226.226,0,0,1-.066.182l-.843.857A2.973,2.973,0,0,0,.4,150.9l1.121,1.941a2.978,2.978,0,0,0,3.314,1.388l1.165-.3a.228.228,0,0,1,.192.035,11.151,11.151,0,0,0,2.21,1.278.223.223,0,0,1,.124.149l.32,1.156a2.976,2.976,0,0,0,2.86,2.176h2.241Zm-3.011-2.755-.32-1.155a2.381,2.381,0,0,0-1.353-1.562,8.979,8.979,0,0,1-1.778-1.028,2.406,2.406,0,0,0-2.031-.393l-1.163.3a.8.8,0,0,1-.892-.373l-1.121-1.942a.8.8,0,0,1,.123-.957L3.24,148a2.381,2.381,0,0,0,.675-1.952,9.027,9.027,0,0,1,0-2.055,2.388,2.388,0,0,0-.674-1.954l-.843-.857a.8.8,0,0,1-.122-.958L3.4,138.278a.8.8,0,0,1,.891-.373l1.163.3a2.381,2.381,0,0,0,2.032-.393,8.98,8.98,0,0,1,1.778-1.029,2.381,2.381,0,0,0,1.353-1.56l.32-1.157a.8.8,0,0,1,.769-.585h2.241a.8.8,0,0,1,.769.585l.319,1.156a2.384,2.384,0,0,0,1.353,1.562,8.946,8.946,0,0,1,1.778,1.029,2.387,2.387,0,0,0,2.031.393l1.163-.3a.8.8,0,0,1,.892.373l1.12,1.941a.8.8,0,0,1-.122.958l-.844.858a2.382,2.382,0,0,0-.675,1.952,9.014,9.014,0,0,1,0,2.053,2.386,2.386,0,0,0,.673,1.953v0l.843.856a.8.8,0,0,1,.122.96l-1.119,1.94a.8.8,0,0,1-.892.373l-1.163-.3a2.389,2.389,0,0,0-2.033.393,8.94,8.94,0,0,1-1.777,1.028,2.383,2.383,0,0,0-1.353,1.562l-.318,1.154a.8.8,0,0,1-.77.587H11.7a.8.8,0,0,1-.769-.586Z",
    transform: "translate(0.001 -120.338)",
    fill: "#f48116"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6071",
    "data-name": "Path 6071",
    d: "M306.42,150.024V132.342a3.1,3.1,0,0,0-3.1-3.1H288.034a3.1,3.1,0,0,0-3.1,3.1v5.9a1.085,1.085,0,1,0,2.17,0v-5.9a.93.93,0,0,1,.929-.929h15.287a.93.93,0,0,1,.929.929v16.623a7.438,7.438,0,0,0-9.371,5.5h-6.846a.93.93,0,0,1-.929-.929v-5.751a1.085,1.085,0,0,0-2.17,0v5.751a3.1,3.1,0,0,0,3.1,3.1h6.689a7.431,7.431,0,1,0,11.7-6.609Zm-4.287,11.329a5.269,5.269,0,0,1-5.263-5.263,5.263,5.263,0,0,1,10.526,0A5.269,5.269,0,0,1,302.133,161.353Z",
    transform: "translate(-254.024 -118.493)",
    fill: "#96006b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6072",
    "data-name": "Path 6072",
    d: "M336.071,191.8h8.57a1.085,1.085,0,0,0,0-2.17h-8.57a1.085,1.085,0,1,0,0,2.17Z",
    transform: "translate(-298.646 -172.327)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6073",
    "data-name": "Path 6073",
    d: "M336.071,247.587h8.57a1.085,1.085,0,0,0,0-2.17h-8.57a1.085,1.085,0,0,0,0,2.17Z",
    transform: "translate(-298.646 -222.065)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6074",
    "data-name": "Path 6074",
    d: "M336.071,305.377h2.86a1.085,1.085,0,1,0,0-2.17h-2.86a1.085,1.085,0,0,0,0,2.17Z",
    transform: "translate(-298.646 -273.585)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6075",
    "data-name": "Path 6075",
    d: "M416.925,357.11l-2.19,2.19-.68-.68a1.085,1.085,0,1,0-1.534,1.534l1.447,1.447a1.085,1.085,0,0,0,1.534,0l2.957-2.957a1.085,1.085,0,1,0-1.534-1.534Z",
    transform: "translate(-367.486 -321.357)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6076",
    "data-name": "Path 6076",
    d: "M127.208,411.624a22.35,22.35,0,0,1-24.161.661l1.6-.255a1.085,1.085,0,0,0-.341-2.143l-4.253.677a1.1,1.1,0,0,0-.877,1.361l.849,4.06a1.085,1.085,0,0,0,2.124-.444l-.3-1.448a24.519,24.519,0,0,0,26.589-.678,1.085,1.085,0,0,0-1.225-1.791Z",
    transform: "translate(-88.384 -368.681)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6077",
    "data-name": "Path 6077",
    d: "M95.822,37.651a1.081,1.081,0,0,0,.689-.247,22.327,22.327,0,0,1,26.31-1.5l-1.68.267a1.085,1.085,0,0,0-.9,1.242,1.1,1.1,0,0,0,1.242.9l4.253-.677a1.1,1.1,0,0,0,.891-1.293l-.863-4.127a1.085,1.085,0,1,0-2.124.444l.287,1.375a24.5,24.5,0,0,0-28.794,1.693,1.085,1.085,0,0,0,.69,1.922Z",
    transform: "translate(-84.459 -30.153)",
    fill: "#ff0185"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6078",
    "data-name": "Path 6078",
    d: "M285.446,248.738a1.084,1.084,0,1,0-.388-1.34A1.092,1.092,0,0,0,285.446,248.738Z",
    transform: "translate(-254.053 -223.269)",
    fill: "#ff0185"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigured);
export default __webpack_public_path__ + "static/media/Configured.3bf4be0e8dc36f8570c981a4d0e2a8d8.svg";
export { ForwardRef as ReactComponent };